(ns dashboard.config)

(goog-define DEV_MODE false)
(goog-define APPLICATION_BASE_DOMAIN "")
